// Screen `objects` — design/screens/DataModel.dc.html — owner: S4.
import { createFileRoute } from '@tanstack/react-router';
import { ObjectsPage } from '../../../../features/data-model/ObjectsPage';

export const Route = createFileRoute('/_settings/settings/objects/')({
  component: ObjectsPage,
});
